<template>
	<div class="view">
		<div class="left">
			<uiList
				class="list"
				:items="filterdPlaces"
				:search="['name']"
				:add="true"
				@click="select"
				@add="add"
			>
				<template slot="header">
					<div class="filters">
						<div
							class="filter"
							:class="{ selected: !filter }"
							@click="filter = null"
						>
							Все
						</div>

						<div
							v-for="category in categories"
							:key="category.id"
							class="filter"
							:class="{ selected: filter === category.id }"
							@click="filter = category.id"
						>
							{{ category.name }}
						</div>
					</div>
				</template>
				<template v-slot:item="{ item }">
					<div class="list-item">
						{{ item.name }}
						<div class="dot" v-if="item.disabled" />
					</div>
				</template>
			</uiList>
		</div>

		<div class="place">
			<div class="global-id">{{ selected.id }}</div>
			<div style="display: flex; align-items: center; margin: 15px 0">
				<div style="width: 100%; flex: 1">Скрыто?</div>
				<uiSwitch style="width: auto" v-model="selected.disabled" />
			</div>
			<uiDevider />
			<uiInput
				class="row"
				v-model="selected.name"
				label="Название в админке"
			/>

			<uiInput
				class="row"
				v-model="selected.locale.en"
				label="EN Название"
			/>
			<uiInput
				class="row"
				v-model="selected.locale.ru"
				label="RU Название"
			/>
			<uiInput
				class="row"
				v-model="selected.locale.he"
				label="HE Название"
			/>

			<uiTextarea
				class="row"
				v-model="selected.description"
				label="Описание в админке"
			/>

			<uiTextarea
				class="row"
				v-model="selected.about.en"
				label="EN Описание"
			/>
			<uiTextarea
				class="row"
				v-model="selected.about.ru"
				label="RU Описание"
			/>
			<uiTextarea
				class="row"
				v-model="selected.about.he"
				label="HE Описание"
			/>

			<uiDropdown
				v-model="selected.category"
				label="Категория"
				style="margin: 5px 0"
				:options="mapCategories"
				:reduce="item => item.value"
			/>
			<uiInput
				class="row"
				v-model="selected.phone"
				label="Телефон"
				mask="+7 999 999 9999"
			/>

			<uiInput class="row" v-model="selectedLat" label="Lat" />
			<uiInput
				class="row"
				v-model="selectedLon"
				label="Lon (иногда пишут как Lng)"
			/>

			<uiInput
				class="row"
				v-model="selected.insta"
				label="Инстаграмчик"
			/>

			<uiInput
				class="row"
				v-model="selected.address"
				label="Адрес (видно только нам)"
			/>

			<uiTextarea
				class="row"
				v-model="selected.notes"
				label="Заметки (видно только нам)"
			/>

			<uiButton class="button" :loading="loading" @click="save">
				{{ button }}
			</uiButton>

			<uiButton
				class="button"
				color="light"
				v-if="this.selected.id !== 'new'"
				:loading="loading"
				@click="remove"
			>
				Удалить
			</uiButton>
		</div>

		<div class="map">
			<MglMap
				:accessToken="mapConfig.token"
				:mapStyle.sync="mapConfig.style"
				@load="onMapLoaded"
			>
				<MglMarker
					v-for="p in filterdPlaces"
					:key="p.id"
					:id="p.id"
					:coordinates="p.location.coordinates"
					@click="onMarkerClick"
				>
					<div class="marker" slot="marker">
						{{ categoriesDict[p.category] }}
					</div>
				</MglMarker>
			</MglMap>

			<div class="cities">
				<uiCard class="card" @click="selectCity('moscow')"
					>Москва</uiCard
				>
				<uiCard class="card" @click="selectCity('piter')">Питер</uiCard>
				<uiCard class="card" @click="selectCity('novosib')"
					>Новосиб</uiCard
				>
				<uiCard class="card" @click="selectCity('krasnodar')"
					>Краснодар</uiCard
				>
				<uiCard class="card" @click="selectCity('sochi')">Сочи</uiCard>
				<uiCard class="card" @click="selectCity('irkutsk')"
					>Иркутск</uiCard
				>
			</div>
		</div>
	</div>
</template>

<script>
import { MglMap, MglMarker } from 'vue-mapbox'
import { API, MAPBOX } from '@/config'

const getBaseSelected = () => ({
	id: 'new',
	name: '',
	description: '',
	category: '',
	phone: '',
	insta: '',
	disabled: false,
	location: {
		type: 'Point',
		coordinates: [0, 0], // lon, lat
	},
	address: '',
	metro: '',
	time: '',
	notes: '',
	locale: {
		en: '',
		ru: '',
		he: '',
	},
	about: {
		en: '',
		ru: '',
		he: '',
	},
})

export default {
	name: 'PetMapPage',
	components: {
		MglMap,
		MglMarker,
	},
	data() {
		return {
			loading: false,
			mapConfig: {
				token: MAPBOX.token,
				style: MAPBOX.style,
			},
			cropping: false,
			filter: null,
			places: [],
			categories: [],
			selectedLat: 0,
			selectedLon: 0,
			selected: getBaseSelected(),
		}
	},
	computed: {
		button() {
			if (this.selected.id === 'new') return 'Создать'
			return 'Сохранить'
		},
		curAvatar() {
			return this.avatar || this.selected.avatar
		},
		filterdPlaces() {
			if (!this.filter) return this.places
			return this.places.filter(p => p.category === this.filter)
		},
		mapCategories() {
			return this.categories.map(({ icon, id, name }) => ({
				label: `${icon} ${name}`,
				value: id,
			}))
		},
		categoriesDict() {
			return this.categories.reduce((acc, { icon, id }) => {
				acc[id] = icon
				return acc
			}, {})
		},
	},
	created() {
		this.map = null
		this.selectNew()
		this.preload()
	},
	methods: {
		async preload() {
			if (this.places.length) return

			let { data } = await this.$http.get(API.SERVICES.petMap)
			if (!data || data.err) return this.$notify(data.err)
			this.places = data

			const { data: categoriesResp } = await this.$http.get(
				API.SERVICES.petMapCategories
			)
			this.categories = categoriesResp.categories
		},
		onMapLoaded(e) {
			this.map = e.map
			this.mapbox = e.component.actions
			this.selectCity('moscow')
		},
		selectCity(e) {
			let cities = {
				moscow: [37.615909, 55.757141],
				piter: [30.315877, 59.939099],
				novosib: [82.92043, 55.030204],
				krasnodar: [38.975313, 45.03547],
				sochi: [39.723098, 43.585472],
				irkutsk: [104.280606, 52.289588],
			}
			// this.mapbox.setCenter(cities[e])
			this.mapbox.jumpTo({
				center: cities[e],
				zoom: 10,
				speed: 3,
			})
		},
		onMarkerClick(e) {
			let id = e?.component?.$attrs.id
			let place = this.places.find(p => p.id == id)
			this.select(place)
		},
		select(e) {
			this.selected = Object.assign(getBaseSelected(), structuredClone(e))
			this.selectedLon = this.selected.location.coordinates[0]
			this.selectedLat = this.selected.location.coordinates[1]
			this.mapbox.jumpTo({
				center: this.selected.location.coordinates,
				zoom: 15,
			})
		},
		selectNew() {
			this.selectedLon = 0
			this.selectedLat = 0
			this.selected = getBaseSelected()
		},
		add() {
			if (this.selected.id === 'new') return
			this.selectNew()
		},
		async save() {
			if (this.loading) return
			this.loading = true

			let payload = JSON.parse(JSON.stringify(this.selected))
			payload.location.coordinates = [
				parseFloat(this.selectedLon),
				parseFloat(this.selectedLat),
			]

			let { data } = await this.$http.post(API.SERVICES.petMap, payload)
			if (!data || data.err) {
				this.$notify(data.err)
				return (this.loading = false)
			}

			let index = this.places.findIndex(p => p.id === data.id)
			this.places.splice(index, 1, data)
			this.selected = data

			this.loading = false
		},
		async remove() {
			let confirm = await this.$confirm(`Точно удаляем?`)
			if (!confirm) return

			if (this.loading) return
			this.loading = true

			let id = this.selected.id
			if (id === 'new') return

			let { data } = await this.$http.delete(API.SERVICES.petMap, { id })
			if (!data || data.err) {
				this.$notify(data.err)
				return (this.loading = false)
			}

			this.selectNew()

			let index = this.places.findIndex(p => p.id === id)
			this.places.splice(index, 1)
			this.loading = false
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
	display: flex;
	// padding: 0 20px;
}

.list {
	.list-item {
		display: block;
		font-size: 16px;
		position: relative;
	}

	.dot {
		width: 6px;
		height: 6px;
		background: @accent;
		position: absolute;
		top: -10px;
		right: -10px;
		border-radius: 50%;
	}
}

.place {
	padding: 0 20px;
	overflow: hidden;
	overflow-y: auto;
	position: relative;
	flex-shrink: 0;

	.row {
		width: 280px;
		margin-bottom: 10px;
	}

	.button {
		margin: 20px 0;
	}
}

.map {
	width: 100%;
	overflow: hidden;

	.cities {
		position: absolute;
		right: 0px;
		top: 60px;
		display: flex;
	}

	.card {
		margin-right: 10px;
		cursor: pointer;

		&:active {
			opacity: 0.8;
			transform: scale(0.98);
		}
	}

	.marker {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background: #fff;
		box-shadow: 0 3px 25px 0px rgba(0, 0, 0, 0.2);
		text-align: center;
		line-height: 30px;
		font-size: 20px;
	}
}

.filters {
	padding: 10px 0;
	font-size: 14px;
	display: flex;
	flex-wrap: wrap;

	.filter {
		padding: 0 10px;
		opacity: 0.3;
		cursor: pointer;

		&.selected {
			opacity: 1;
		}
	}
}
</style>
